import type {
    DashboardDeviceDowntimeOverviewResponse,
    DashboardDeviceMaintenanceOverviewResponse,
    DashboardDeviceOverviewResponse,
    DashboardExpectedValueOverviewResponse,
    DashboardProductivityOverviewResponse,
    DashboardTopDeviceOverviewResponse,
} from '@/types/apps/dashboard-v2.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';

export class DashboardV2Service {
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        deviceOverview: () => '/api/v2/dashboard/device-overview',
        deviceMaintenanceOverview: () =>
            '/api/v2/dashboard/device-maintenance-overview',
        expectedValueOverview: () =>
            '/api/v2/dashboard/expected-value-overview',
        productivityOverview: () => '/api/v2/dashboard/productivity-overview',
        deviceDowntimeOverview: () =>
            '/api/v2/dashboard/device-downtime-overview',
        topDeviceOverview: () => '/api/v2/dashboard/top-device-overview',
    };

    public getDeviceOverview(
        params?: QueryParams
    ): Promise<ApiResponse<DashboardDeviceOverviewResponse>> {
        return this.apiClient.fetchApi(this.endpoints.deviceOverview(), params);
    }

    public getDeviceMaintenanceOverview(
        params?: QueryParams
    ): Promise<ApiResponse<DashboardDeviceMaintenanceOverviewResponse>> {
        return this.apiClient.fetchApi(
            this.endpoints.deviceMaintenanceOverview(),
            params
        );
    }

    public getExpectedValueOverview(
        params?: QueryParams
    ): Promise<
        ApiResponse<PaginatedResult<DashboardExpectedValueOverviewResponse>>
    > {
        return this.apiClient.fetchApi(
            this.endpoints.expectedValueOverview(),
            params
        );
    }

    public getProductivityOverview(
        params?: QueryParams
    ): Promise<ApiResponse<DashboardProductivityOverviewResponse[]>> {
        return this.apiClient.fetchApi(
            this.endpoints.productivityOverview(),
            params
        );
    }

    public getDeviceDowntimeOverview(
        params?: QueryParams
    ): Promise<ApiResponse<DashboardDeviceDowntimeOverviewResponse>> {
        return this.apiClient.fetchApi(
            this.endpoints.deviceDowntimeOverview(),
            params
        );
    }

    public getTopDeviceOverview(
        params?: QueryParams
    ): Promise<
        ApiResponse<PaginatedResult<DashboardTopDeviceOverviewResponse>>
    > {
        return this.apiClient.fetchApi(
            this.endpoints.topDeviceOverview(),
            params
        );
    }
}
